//LIBRARIES
import { Field, reduxForm, hasSubmitFailed } from 'redux-form';
import { localize } from 'react-localize-redux';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

//HELPERS
import { hostIsCapreitERES } from 'helpers/CurrentWindowLocation';
import { BooleanRadioButtons } from 'helpers/BooleanRadioButtons';
import { AccentColor } from 'helpers/AccentColorHelper';
import * as validator from 'helpers/Validator';

//COMPONENTS
import { TextField, SelectField } from 'redux-form-material-ui';
import CtaPrimary from 'components/ui/CtaPrimary';
import MenuItem from 'material-ui/MenuItem';

class TenantMaintenanceSurveyForm extends Component {
  render() {
    const handleSubmit = this.props.handleSubmit;

    return (
      <form onSubmit={handleSubmit} style={{ marginTop: '24px' }}>
        <h5
          style={{
            textAlign: 'left',
            marginBottom: '16px',
          }}
        >
          {this.props.translate('maintenanceSurvey.wasTheWorkPerformed')}
        </h5>
        <BooleanRadioButtons name="happy" style={{ margin: 'auto' }} stackRadio />
        <h5
          style={{
            textAlign: 'left',
            marginBottom: '16px',
            marginTop: '30px',
          }}
        >
          {' '}
          {this.props.translate('maintenanceSurvey.onAScaleFrom')}{' '}
          {!hostIsCapreitERES() && this.props.landlord_name}?
        </h5>
        <Field
          name="recommendation"
          component={SelectField}
          hintText={this.props.translate('maintenanceSurvey.field.recommendation')}
          style={{
            marginTop: '0px',
            fontSize: '14px',
            textAlign: 'left',
          }}
          validate={[validator.required]}
          fullWidth
        >
          <MenuItem value={'10'} primaryText={'10'} />
          <MenuItem value={'9'} primaryText={'9'} />
          <MenuItem value={'8'} primaryText={'8'} />
          <MenuItem value={'7'} primaryText={'7'} />
          <MenuItem value={'6'} primaryText={'6'} />
          <MenuItem value={'5'} primaryText={'5'} />
          <MenuItem value={'4'} primaryText={'4'} />
          <MenuItem value={'3'} primaryText={'3'} />
          <MenuItem value={'2'} primaryText={'2'} />
          <MenuItem value={'1'} primaryText={'1'} />
        </Field>
        {this.props.showContactField && (
          <Fragment>
            <h5
              style={{
                textAlign: 'left',
                marginBottom: '16px',
                marginTop: '15px',
              }}
            >
              {' '}
              {this.props.translate('maintenanceSurvey.wouldYouLike')}
            </h5>
            <BooleanRadioButtons name="contact" stackRadio />
          </Fragment>
        )}
        <h5
          style={{
            textAlign: 'left',
            marginBottom: '16px',
            marginTop: '30px',
          }}
        >
          {' '}
          {this.props.translate('maintenanceSurvey.ifYouWouldLike')}{' '}
        </h5>
        <Field
          name="comments"
          component={TextField}
          hintText={this.props.translate('maintenanceSurvey.field.comments')}
          hintStyle={{ textAlign: 'left' }}
          multiLine
          rows={2}
          fullWidth
          errorStyle={{ display: 'none' }}
          style={{ fontSize: '14px', marginBottom: '15px' }}
        />
        {this.props.submitFailed && (
          <div style={{ color: 'red', marginBottom: '10px' }}>
            {' '}
            {this.props.translate('maintenanceSurvey.woopsPleaseFill')}{' '}
          </div>
        )}
        <div>
          <CtaPrimary accentColor={AccentColor()} type="submit">
            {this.props.translate('submit')}
          </CtaPrimary>
        </div>
        <div style={{ marginTop: '50px' }} />
      </form>
    );
  }
}

TenantMaintenanceSurveyForm = reduxForm({
  form: 'TenantMaintenanceSurveyForm',
})(TenantMaintenanceSurveyForm);

TenantMaintenanceSurveyForm = connect(state => ({
  submitFailed: hasSubmitFailed('TenantMaintenanceSurveyForm')(state),
}))(TenantMaintenanceSurveyForm);

export default localize()(TenantMaintenanceSurveyForm);
